import { filterEmpty } from "types/navigation/common";
import { PropertyFilter } from "types/navigation/propertyNavigation";

export const DEFAULT_PROPERTY_TABLE_SORT = { id: "name", desc: false };

export const BASE_PROPERTY_FILTERS: PropertyFilter = {
  address_city: filterEmpty,
  address_state: filterEmpty,
};
